<template>
  <div class="login-page">
    <div class="login-gradient">
      <div class="login-logo-wrapper">
        <img class="login-logo" src="../assets/Logo-sk.png" alt="Super Kompras" />
      </div>

      <div class="login-card-custom shadow-lg">
        <h2 class="login-title">Recuperar Contraseña</h2>
        <p class="login-subtitle">
          Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña
        </p>

        <div v-if="error" class="login-alert login-alert-error" role="alert">
          <i class="fa-solid fa-circle-exclamation"></i>
          <span>{{ error }}</span>
        </div>
        <div v-if="enviado" class="login-alert login-alert-success" role="status">
          <i class="fa-solid fa-circle-check"></i>
          <span>{{ enviado }}</span>
        </div>

        <form @submit.prevent="enviar">
          <div class="mb-3">
            <label class="form-label">Correo Electrónico</label>
            <input v-model.trim="email" type="email" class="form-control login-input" placeholder="email@ejemplo.com"
              required />
          </div>

          <button type="submit" class="btn btn-login w-100 mt-2" :disabled="enviando">
            {{ enviando ? 'Enviando...' : 'Enviar Correo de Recuperación' }}
          </button>
        </form>

        <div class="text-center mt-3">
          <router-link to="/auth/login" class="login-link">
            <i class="fa-solid fa-arrow-left me-1"></i> Volver al inicio de sesión
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RecuperarContrasena",
  data() {
    return {
      email: this.$route.query.correo || "",
      enviando: false,
      error: "",
      enviado: "",
    };
  },
  methods: {
    async enviar() {
      this.error = "";
      this.enviado = "";
      if (!this.email) {
        this.error = "Ingresa tu correo electrónico";
        return;
      }

      this.enviando = true;
      try {
        const data = await this.$store.dispatch("autenticacion/solicitarRestablecimiento", {
          correo: this.email,
        });
        this.enviado = data.msg;
      } catch (e) {
        this.error = e.msg || "No se pudo enviar el correo. Verifica tu conexión con el servidor.";
      } finally {
        this.enviando = false;
      }
    },
  },
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #f7f7ff 0%, #6f6cfb 100%);
}

.login-gradient {
  width: 100%;
  padding: 40px 16px 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.login-logo-wrapper {
  margin-bottom: 32px;
}

.login-logo {
  max-width: 260px;
  height: auto;
}

.login-card-custom {
  background: #ffffff;
  border-radius: 24px;
  padding: 40px 48px 36px;
  max-width: 480px;
  width: 100%;
}

.login-title {
  font-size: 28px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 8px;
  color: #222222;
}

.login-subtitle {
  text-align: center;
  margin-bottom: 24px;
  color: #8a8ba0;
}

.login-alert {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 14px 16px;
  margin-bottom: 20px;
  border-radius: 10px;
  color: #ffffff;
  font-size: 0.95rem;
  line-height: 1.4;
}

.login-alert i {
  margin-top: 3px;
}

.login-alert-error {
  background: #ff4b7b;
}

.login-alert-success {
  background: #10b981;
}

.login-input {
  border-radius: 999px;
  padding: 10px 18px;
  border: 1px solid #e0e0f0;
  box-shadow: none;
}

.login-input:focus {
  border-color: #6f6cfb;
  box-shadow: 0 0 0 0.1rem rgba(111, 108, 251, 0.25);
}

.login-link {
  font-size: 0.9rem;
  text-decoration: none;
  color: #6f6cfb;
}

.login-link:hover {
  text-decoration: underline;
}

.btn-login {
  border-radius: 999px;
  background: #6f6cfb;
  border-color: #6f6cfb;
  color: #ffffff;
  font-weight: 600;
  padding: 10px 16px;
}

.btn-login:hover,
.btn-login:focus-visible,
.btn-login:active {
  background: #5c59e8;
  border-color: #5c59e8;
  color: #ffffff;
}

.btn-login:disabled {
  opacity: 0.7;
}

@media (max-width: 576px) {
  .login-card-custom {
    padding: 28px 20px 24px;
    border-radius: 16px;
  }

  .login-logo {
    max-width: 200px;
  }
}
</style>
